/**
 * Which "world" an account's contract belongs to, derived by the platform service from the V2
 * companies `contractType`. Exposed on `ProductFeatureData.accountWorld` as metadata — it does NOT
 * affect `hasFeature()` resolution.
 */
export const AccountWorld = {
  /** New World — `contractType` ∈ NONE…THIRD_PARTY. */
  NewWorld: 'NEW_WORLD',
  /** Migrated / legacy — `contractType` = LEGACY. */
  Legacy: 'LEGACY',
  /** Unknown — the company fetch failed or the response carried no `contractType`. */
  Unknown: 'UNKNOWN',
} as const;

export type AccountWorldValue =
  (typeof AccountWorld)[keyof typeof AccountWorld];
